import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators  } from '@angular/forms';
import { ApisService } from 'src/app/service/APIs/apis.service';
import { AlertServiceService } from 'src/app/service/alert/alert-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements OnInit {
  public billingForm: FormGroup | any | undefined;

  public number:any = "Order123-qaz";
  public amount: Number = 1000;
  public currency:any = "NG"
  public description:any = "A nice device for your use"
  public merchant_key:any = "7084d73a-6850-11ee-abcc-6af4ec846580"
  public hash:any = "17c66549dcfbb10dd45b540706466c4b7e32dd3c"


  constructor(
    private apiService: ApisService,
    private formBuilder: FormBuilder,
    private alert: AlertServiceService
  ) { }

//   {  
//     "merchant_key":"7084d73a-6850-11ee-abcc-6af4ec846580",
//     "operation":"purchase",
//     "methods":[
//         "card"
//     ],
//     "order":{
//        "number":"order-1234",
//        "amount": "0.19",
//        "currency":"USD",
//        "description":"Important gift"
//     },
//     "cancel_url":"https://example.com/cancel",
//     "success_url":"https://example.com/success",
//     "customer":{
//        "name":"John Doe",
//        "email":"test@email.com"
//     },
//     "billing_address":{
//        "country":"US",
//        "state": "CA",
//        "city":"Los Angeles",
//        "address":"Moor Building 35274",
//        "zip":"123456",
//        "phone":"347771112233"
//       },
//     "recurring_init": "true",
//     "hash":"{{session_hash}}"
//  }

cancel(){
  console.log('i am canselled');
  
}

checkout(){
  this.alert.showLoading();

  // console.log('formdetails', this.billingForm.value);
  let data: any = {
        "merchant_key":this.merchant_key,
    "operation":"purchase",
    "methods":[
        "card"
    ],
    "order":{
       number:this.number,
       amount: this.amount,
       currency:this.currency,
       description:this.description
    },
    "cancel_url":"https://example.com/cancel",
    "success_url":"https://example.com/success",
    "customer":{
       name:this.billingForm.value.firstName + " " + this.billingForm.value.lastName,
       email:this.billingForm.value.email
    },
    "billing_address":{
       country:this.billingForm.value.country,
       state: this.billingForm.value.state,
       city:this.billingForm.value.city,
       address:this.billingForm.value.address,
       zip:this.billingForm.value.zip,
       phone:this.billingForm.value.phone
      },
    "recurring_init": "true",
    "hash":this.hash
    }
  // console.log('final obj', data);

  //  return window.location.assign("https://pay.huiospay.com//api/v1/session?merchant_key=7084d73a-6850-11ee-abcc-6af4ec846580&CHECKOUT_HOST=https://pay.huiospay.com")
  
  this.apiService.checkout(data)
  .subscribe({
    next: (data: any) => {
      // console.log('response', data);
      this.alert.successPop(data?.message);
    },
    error: (err) => {
      // console.log("error", err)
      this.alert.errorPop('Error in sending message')

    }
  })

}

  ngOnInit(): void {
    this.billingForm = this.formBuilder.group({
      orderNo: [this.number, [Validators.required]],
      amount: [this.amount, [Validators.required]],
      currency: [this.currency, [Validators.required]],
      description: [this.description, [Validators.required]],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      email: ['', [Validators.required]],
      country: ['', [Validators.required]],
      state: ['', [Validators.required]],
      city: ['', [Validators.required]],
      address: ['', [Validators.required]],
      zip: ['', [Validators.required]],
      phone: ['', [Validators.required]],
    });
  }

}
